module.exports = __webpack_public_path__ + "img/tempFile.22b9b7a3.svg";